import React from 'react'
import { OffersList } from './list/page'

export const OffersPage: React.FC = (): JSX.Element => {
  return <OffersList />
}
